/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AWSRegionsEnum = 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2';

export const AWSRegionsEnum = {

    AP_EAST_1: 'ap-east-1' as AWSRegionsEnum,

    AP_NORTHEAST_1: 'ap-northeast-1' as AWSRegionsEnum,

    AP_NORTHEAST_2: 'ap-northeast-2' as AWSRegionsEnum,

    AP_NORTHEAST_3: 'ap-northeast-3' as AWSRegionsEnum,

    AP_SOUTH_1: 'ap-south-1' as AWSRegionsEnum,

    AP_SOUTH_2: 'ap-south-2' as AWSRegionsEnum,

    AP_SOUTHEAST_1: 'ap-southeast-1' as AWSRegionsEnum,

    AP_SOUTHEAST_2: 'ap-southeast-2' as AWSRegionsEnum,

    AP_SOUTHEAST_3: 'ap-southeast-3' as AWSRegionsEnum,

    AP_SOUTHEAST_4: 'ap-southeast-4' as AWSRegionsEnum,

    AF_SOUTH_1: 'af-south-1' as AWSRegionsEnum,

    EU_CENTRAL_1: 'eu-central-1' as AWSRegionsEnum,

    EU_CENTRAL_2: 'eu-central-2' as AWSRegionsEnum,

    EU_NORTH_1: 'eu-north-1' as AWSRegionsEnum,

    EU_SOUTH_1: 'eu-south-1' as AWSRegionsEnum,

    EU_WEST_1: 'eu-west-1' as AWSRegionsEnum,

    EU_WEST_2: 'eu-west-2' as AWSRegionsEnum,

    EU_WEST_3: 'eu-west-3' as AWSRegionsEnum,

    ME_CENTRAL_1: 'me-central-1' as AWSRegionsEnum,

    ME_SOUTH_1: 'me-south-1' as AWSRegionsEnum,

    SA_EAST_1: 'sa-east-1' as AWSRegionsEnum,

    CA_CENTRAL_1: 'ca-central-1' as AWSRegionsEnum,

    US_EAST_1: 'us-east-1' as AWSRegionsEnum,

    US_EAST_2: 'us-east-2' as AWSRegionsEnum,

    US_WEST_1: 'us-west-1' as AWSRegionsEnum,

    US_WEST_2: 'us-west-2' as AWSRegionsEnum
};

